import React from 'react';

const TermsOfService = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <div className="prose max-w-none">
        <p className="mb-4"><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
        
        <h2 className="text-2xl font-semibold mt-6 mb-3">Acceptance of Terms</h2>
        <p className="mb-4">
          By accessing and using Seb7at Store, you accept and agree to be bound by the terms 
          and provision of this agreement.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Account Registration</h2>
        <p className="mb-4">
          When you create an account with us, you must provide information that is accurate, 
          complete, and current at all times. You are responsible for safeguarding the password 
          and for all activities that occur under your account.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Google Sign-In Terms</h2>
        <p className="mb-4">
          When using Google Sign-In:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>You agree to Google's Terms of Service</li>
          <li>We will only access your basic profile information</li>
          <li>You can revoke access at any time through your Google account settings</li>
          <li>We do not store your Google password or access other Google services</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Orders and Payments</h2>
        <p className="mb-4">
          All orders are subject to availability and confirmation of the order price. 
          We reserve the right to refuse any order you place with us.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-3">User Conduct</h2>
        <p className="mb-4">You agree not to:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>Use the service for any unlawful purpose</li>
          <li>Interfere with or disrupt the service</li>
          <li>Attempt to gain unauthorized access to the service</li>
          <li>Violate any applicable laws or regulations</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Limitation of Liability</h2>
        <p className="mb-4">
          In no event shall Seb7at Store be liable for any indirect, incidental, special, 
          consequential, or punitive damages arising out of your use of the service.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-3">Contact Information</h2>
        <p className="mb-4">
          Questions about the Terms of Service should be sent to us at:
        </p>
        <p className="mb-4">
          Email: seb7at.kw@gmail.com<br />
          Address: Kuwait
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
